<ng-container *ngIf="items?.length;else noItems">
    <div class="swiper-wrapper">
        <swiper-container #swiper 
        space-between="30" css-mode="true" 
        navigation 
        pagination
        loop="true">
            <swiper-slide *ngFor="let item of items" class="swiper-item">
                <div class="carousel-item">
                    <div class="image-container" *ngIf="item.image">
                        <img [ngSrc]="item.image" fill alt="{{ item.image }}"
                            class="img-reponsive rounded img-features">
                    </div>
                </div>
                <div class="carousel-caption mb--24">
                    <h4 class="carousel-title" [innerHTML]="item.title | translate" *ngIf="item.title"></h4>
                    <h5 class="carousel-subtitle text-primary" [innerHTML]="item.subtitle | translate"
                        *ngIf="item.subtitle"></h5>
                    <div class="carousel-description" [innerHTML]="item.content | translate" *ngIf="item.content"></div>
                </div>
                <div class="carousel-action" *ngIf="item.button?.label">
                    <button mat-striked-button color="primary" (click)="clickedAction(item)">{{item.button}}</button>
                </div>
            </swiper-slide>
        </swiper-container>
        <div #prevElButton class="swiper-nav-button swiper-button-prev-unique" (click)="prevSlide()">
            <span class="material-icons">
                chevron_left
            </span>
        </div>
        <div #nextElButton class="swiper-nav-button swiper-button-next-unique" (click)="nextSlide()">
            <span class="material-icons">
                chevron_right
            </span>
        </div>
    </div>
</ng-container>
<ng-template #noItems>
    <div class="no-items">
        <p>No slides</p>
    </div>
</ng-template>